export const openInNewTab = (url) => {
  window.open(url, '_blank', 'noreferrer');
};
